<template>
  <nav
    id="sidebar"
    :class="[userDelegator && 'mt-5', 'navbar navbar-vertical fixed-left navbar-expand-md navbar-light']">
    <div class="container-fluid">
      <!-- Toggler -->
      <button
        aria-controls="sidebarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler"
        data-target="#sidebarCollapse"
        data-toggle="collapse"
        type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Brand -->
      <router-link :to="{ path: '/' }" class="navbar-brand">
        <img alt="..." class="navbar-brand-img mx-auto" src="@/assets/img/logo.svg" />
      </router-link>
      <div class="d-none d-md-block d-lg-block d-xl-block">
        <div class="version">{{ version }}</div>
        <div v-if="server && server !== 'production'" class="server">
          <div
            :class="server === 'test' ? 'bg-danger text-white' : 'bg-primary-soft'"
            class="badge font-weight-bold"
            style="font-size: 1rem">
            {{ server }}
          </div>
        </div>
      </div>
      <!-- User (xs) -->
      <div class="navbar-user d-md-none">
        <!-- Dropdown -->
        <div class="dropdown">
          <!-- Toggle -->
          <a
            id="sidebarIcon"
            aria-expanded="false"
            aria-haspopup="true"
            class="dropdown-toggle"
            data-toggle="dropdown"
            role="button">
            <div class="avatar avatar-sm avatar-online">
              <img
                alt="..."
                class="avatar-img rounded-circle"
                src="data:image/png;base64,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" />
            </div>
          </a>
          <!-- Menu -->
          <div aria-labelledby="sidebarIcon" class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-item">
              {{ user.name }}
              <br />
              <div class="font-size-sm">{{ user.email }}</div>
            </div>
            <hr class="dropdown-divider" />
            <a class="dropdown-item">{{ $t('dashboard.term.settings') }}</a>
            <hr class="dropdown-divider" />
            <a class="dropdown-item" @click="showUsers">
              {{ $t('dashboard.term.userLoginAs') }}
            </a>
            <hr class="dropdown-divider" />
            <a class="dropdown-item" @click="logout()">{{ $t('dashboard.term.logout') }}</a>
          </div>
        </div>
      </div>
      <!-- Collapse -->
      <div id="sidebarCollapse" class="collapse navbar-collapse">
        <!-- Form -->
        <form class="mt-4 mb-3 d-md-none">
          <div class="input-group input-group-rounded input-group-merge">
            <input
              aria-label="Search"
              class="form-control form-control-rounded form-control-prepended"
              placeholder="Search"
              type="search" />
            <div class="input-group-prepend">
              <div class="input-group-text">
                <span class="fe fe-search"></span>
              </div>
            </div>
          </div>
        </form>
        <ul class="navbar-nav">
          <li class="nav-item">
            <div class="user-info">
              <i class="fe fe-user"></i>
              {{ user.name }}
              <br />
              <i class="fe fe-mail"></i>
              {{ user.email }}
            </div>
          </li>
        </ul>
        <!-- Heading -->
        <h6 class="navbar-heading">{{ $t('dashboard.term.labelData') }}</h6>
        <!-- Navigation -->
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link :to="{ name: 'dashboard-project-list' }" class="nav-link">
              <i class="fe fe-grid"></i>
              {{ $t('dashboard.term.dashboard') }}
            </router-link>
          </li>
          <!--          <li class="nav-item">-->
          <!--            <a class="nav-link " href="./widgets.html">-->
          <!--              <i class="fe fe-target"></i> {{ $t('dashboard.term.point') }}-->
          <!--            </a>-->
          <!--          </li>-->
        </ul>
        <!-- Heading -->
        <h6 class="navbar-heading">{{ $t('dashboard.term.reviewData') }}</h6>
        <!-- Navigation -->
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link :to="{ name: 'dashboard-project-list-reviewer' }" class="nav-link">
              <i class="fe fe-check-square"></i>
              {{ $t('dashboard.term.dashboard') }}
            </router-link>
          </li>
        </ul>
        <template v-if="workspaces && workspaces.results.length > 0">
          <hr class="navbar-divider my-3" />
          <h6 class="navbar-heading">{{ $t('dashboard.term.workspace') }}</h6>
          <ul class="navbar-nav">
            <li class="nav-item">
              <div class="nav-link">
                <b-form-select v-model="workspace.code" size="sm">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      -- {{ $t('dashboard.auth.workspace_list.title') }} --
                    </b-form-select-option>
                  </template>
                  <b-form-select-option v-for="w in workspaces.results" :key="w.code" :value="w.code">
                    {{ w.name }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </li>
          </ul>
        </template>
        <template v-if="workspaces && workspaces.results.length > 0 && workspace.code">
          <!-- Divider -->
          <hr class="navbar-divider my-3" />
          <!-- Heading -->
          <h6 class="navbar-heading">
            {{ $t('dashboard.term.manageProject') }}
          </h6>
          <!-- Navigation -->
          <ul class="navbar-nav mb-md-4">
            <li class="nav-item">
              <router-link :to="{ name: 'dataset-list' }" class="nav-link">
                <i class="fe fe-database"></i>
                {{ $t('dashboard.term.dataset') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'project-list' }" class="nav-link">
                <i class="fe fe-activity"></i>
                {{ $t('dashboard.term.project') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'neural-net-list' }" class="nav-link">
                <i class="fe fe-cpu"></i>
                {{ $t('dashboard.term.ml') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'integration-detail' }" class="nav-link">
                <i class="fe fe-layers"></i>
                {{ $t('dashboard.term.integration') }}
              </router-link>
            </li>
          </ul>
          <!-- Divider -->
          <hr class="navbar-divider my-3" />
          <!-- Heading -->
          <h6 class="navbar-heading">{{ $t('dashboard.term.member') }}</h6>
          <!-- Navigation -->
          <ul class="navbar-nav mb-md-4">
            <li class="nav-item">
              <router-link :to="{ name: 'member-list' }" class="nav-link">
                <i class="fe fe-user"></i>
                {{ $t('dashboard.term.member') }}
              </router-link>
            </li>
          </ul>
        </template>
        <!-- Push content down -->
        <div class="mt-auto"></div>
        <!-- User (md) -->
        <div id="sidebarUser" class="navbar-user d-none d-md-flex">
          <!-- Icon -->
          <a class="navbar-user-link" data-toggle="modal" href="#sidebarModalActivity">
            <span class="icon">
              <i class="fe fe-bell"></i>
            </span>
          </a>
          <!-- Dropup -->
          <div class="dropup">
            <!-- Toggle -->
            <a
              id="sidebarIconCopy"
              aria-expanded="false"
              aria-haspopup="true"
              class="navbar-user-link"
              data-toggle="dropdown"
              role="button">
              <span class="icon">
                <i class="fe fe-user"></i>
              </span>
            </a>
            <!-- Menu -->
            <div aria-labelledby="sidebarIconCopy" class="dropdown-menu">
              <div class="dropdown-item">
                {{ user.name }}
                <br />
                <div class="font-size-sm">{{ user.email }}</div>
              </div>
              <hr class="dropdown-divider" />
              <router-link :to="{ name: 'setting-account' }" class="dropdown-item">
                {{ $t('dashboard.term.settings') }}
              </router-link>
              <template v-if="user.can_login_as_another_user && !userDelegator">
                <hr class="dropdown-divider" />
                <div class="dropdown-item" style="cursor: pointer" @click="showUsers">
                  {{ $t('dashboard.term.userLoginAs') }}
                </div>
              </template>
              <hr class="dropdown-divider" />
              <a class="dropdown-item" @click="logout()">{{ $t('dashboard.term.logout') }}</a>
            </div>
          </div>
          <div class="dropup">
            <!-- Toggle -->
            <a
              id="sidebarIconLocale"
              aria-expanded="false"
              aria-haspopup="true"
              class="navbar-user-link"
              data-toggle="dropdown"
              role="button">
              <span class="icon text-uppercase">
                {{ $i18n.locale }}
              </span>
            </a>
            <!-- Menu -->
            <div id="dropdown" aria-labelledby="sidebarIconLocale" class="dropdown-menu">
              <a class="dropdown-item" @click="changeLocale('ko')">한국어</a>
              <a class="dropdown-item" @click="changeLocale('en')">ENGLISH</a>
            </div>
          </div>
        </div>
      </div>
      <!-- / .navbar-collapse -->
    </div>
    <b-modal id="bv-modal-users" hide-footer size="lg">
      <template #modal-title>
        <div>{{ $t('dashboard.term.memberList') }}</div>
      </template>
      <div class="list-group list-group-flush list-group-activity mx-0 my-0">
        <ListTableCard
          :allow-keyword-search="true"
          :fields="fields"
          :items="users"
          :responsive="'sm'"
          :search-options="searchOptions">
          <template #cell(login)="data">
            <a href="javascript:void(0);" @click="loginAsAnotherUser(data.item)">
              {{ $t('dashboard.term.logIn') }}
            </a>
          </template>
        </ListTableCard>
      </div>
    </b-modal>
  </nav>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from '@vue/composition-api'
import stringify from 'fast-json-stable-stringify'
import packageJson from '../../../../../package.json'
import { useI18n, useRouter } from '@/app/core/lib/util'
import UserService from '@/app/dashboard/services/user-service'
import WorkspaceService from '@/app/dashboard/services/workspace-service'
import { AuthToken } from '@/app/shared/auth/auth-token'
import { WorkspaceToken } from '@/app/shared/auth/workspace-token'

const ListTableCard = () => import('@/app/dashboard/components/shared/list/list-table-card')

export default {
  name: 'TheNavigation',
  components: { ListTableCard },
  setup(props, { root: { $store, $bvModal } }) {
    const { route } = useRouter()
    const { t } = useI18n()
    const workspace = ref({ code: WorkspaceToken.get() })
    const workspaces = ref(null)
    const { router } = useRouter()
    const user = JSON.parse(localStorage.getItem('user'))
    const userDelegator = JSON.parse(localStorage.getItem('userDelegator'))
    const server = ref(process.env.NODE_ENV)
    const version = ref(`v${packageJson.version}`)
    const users = ref(null)
    const currentWorkspace = ref({ name: '' })

    onMounted(async () => {
      workspaces.value = await WorkspaceService.list()
    })

    watch(workspaces, (v) => {
      currentWorkspace.value = v.results.find((d) => d.code === workspace.value.code)
    })

    watch(
      computed(() => workspace.value.code),
      (newValue) => {
        WorkspaceToken.set(newValue, true)
        $store.dispatch('dashboard/refreshDashboard')
      }
    )

    const logout = () => {
      AuthToken.set('', true)
      localStorage.setItem('userDelegator', null)
      router.push({ name: 'login' }).catch(() => {
        logout()
      })
    }

    const fields = [
      {
        key: 'name',
        label: t('dashboard.term.name')
      },
      {
        key: 'email',
        label: t('dashboard.term.emailAddress')
      },
      {
        key: 'login',
        label: t('dashboard.term.logIn')
      }
    ]

    const searchOptions = reactive({
      page: route.value.query.page || 1,
      page_size: 10,
      search: route.value.query.search || '',
      ordering: 'id'
    })

    const showUsers = async () => {
      await searchUsers()
      $bvModal.show('bv-modal-users')
    }

    const searchUsers = async () => {
      users.value = await UserService.list(searchOptions)
    }

    watch(searchOptions, () => {
      searchUsers()
    })

    const loginAsAnotherUser = (data) => {
      localStorage.setItem('userDelegator', localStorage.getItem('user'))
      localStorage.setItem('user', stringify(data))
      WorkspaceToken.set('', false)
      location.href = '/'
    }
    const { i18n } = useI18n()
    const changeLocale = (code) => {
      localStorage.setItem('locale', code)
      i18n.locale = code
      document.title = t('datamakerSynapse')
    }

    return {
      workspace,
      workspaces,
      logout,
      currentWorkspace,
      changeLocale,
      user,
      version,
      server,
      showUsers,
      users,
      searchOptions,
      fields,
      loginAsAnotherUser,
      userDelegator
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    li {
      a {
        color: #6e84a3;
        &:hover {
          color: #000;
        }
      }
    }
  }
}

#dropdown {
  margin-left: -60px;
}

.user-info {
  margin: 25px;
  border-top: 1px solid #e3ebf6;
  border-bottom: 1px solid #e3ebf6;
  font-size: 0.8rem;
  color: #6e84a3;
  padding: 10px 0;

  .logout {
    float: right;
    font-size: 0.7rem;
  }
}

.version {
  font-size: 0.7rem;
  text-align: right;
  color: #6e84a3;
  margin-top: -15px;
}

.dropdown-item {
  cursor: pointer;
}

.server {
  text-align: right;
  margin-top: 10px;
}
</style>
